module.exports = __webpack_public_path__ + "img/xbox-blue.7bae61c8.png";